import { useNavigate } from 'react-router';

export default function useNavigateReload() {
  return useNavigate();
  /**/
}

export function useForceReload() {
  return (url: string) => {
    const href = document.createElement('a');
    href.setAttribute('href', url);
    href.click();
    href.remove();
  };
}
